import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import EqCset from '../models/data/EqCset';
import EqCsetRequest, {
  EqCsetDetailRequest,
} from '../models/requests/GetEqCset';

// 設備改造情報の取得関数
export default function requestEqCsetList(
  url: string,
  params?: EqCsetRequest,
): Promise<AxiosResponse<EqCset[]>> {
  const config = createRequestConfig({ params });
  return axios.get<EqCset[]>(url, config);
}

// 設備改造情報件数の取得関数
export function requestCountEqCset(
  url: string,
  params?: EqCsetRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 設備改造の詳細情報の取得関数
export function requestEqCsetDetail(
  url: string,
  params?: EqCsetDetailRequest,
): Promise<AxiosResponse<EqCset>> {
  const config = createRequestConfig({ params });
  return axios.get<EqCset>(url, config);
}
